import React, { FormEvent } from "react";
import { Input } from "../atoms/input";

function InputButton({
  text,
  handleUpload,
  className,
}: {
  className?: string;
  text: string;
  handleUpload: (e: FormEvent<HTMLInputElement>) => Promise<void>;
}) {
  return (
    <label
      className={`p-2 rounded-md border text-sm font-semibold border-zinc-950/10 text-zinc-950 ${className}`}>
      {text}
      <Input
        id="file-upload-input"
        type="file"
        className={"hidden"}
        onChange={handleUpload}
      />
    </label>
  );
}

export default InputButton;
